"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraButton = void 0;
const react_1 = __importDefault(require("react"));
require("../styles/eura-button.css");
const EuraButton = (props) => {
    var _a, _b;
    const classConstruct = [props.primary ? 'eura-button-primary' : 'eura-button', (_a = props.className) !== null && _a !== void 0 ? _a : ''];
    return (react_1.default.createElement("button", { disabled: props.disabled, "aria-label": props.ariaLabel, type: props.type ? props.type : 'button', onClick: props.onClick, "data-testid": props.dataTestId, className: classConstruct.join(' '), tabIndex: (_b = props.tabIndex) !== null && _b !== void 0 ? _b : 0, form: props.form }, props.label));
};
exports.EuraButton = EuraButton;
